import { createAction } from "@ngrx/store";

export const LOGOUT = createAction('[ APP ] LOGOUT');